import type { ExportAttempt } from '../types';

import { ENDPOINT } from '~/constants/endpoints';

import type { UUID } from '~/types/common';

import type { KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import { zodExportAttemptSchema } from '../validations';

/**
 * Fetches one outbound export attempt for an invoice.
 *
 * @param invoiceId - Invoice identifier.
 * @param attemptId - Export attempt identifier.
 * @param options - Request options supplied by TanStack Query.
 * @returns Export attempt details.
 * @see https://app.dev.vestigas.com/redoc#tag/Invoices/operation/get_export_attempt_invoices__invoice_id__export_attempts__attempt_id__get
 */
export async function fetchInvoiceExportAttempt(
  invoiceId: UUID,
  attemptId: UUID,
  options?: KyRequestOptions,
) {
  return vestigasApi
    .get(ENDPOINT.INVOICE.GET_EXPORT_ATTEMPT(invoiceId, attemptId), {
      ...options,
      validate: {
        ...options?.validate,
        isResponseSensitive: true,
        response: zodExportAttemptSchema,
      },
    })
    .json<ExportAttempt>();
}
